import type { AgentConversation } from '@/agent/conversations/store/slice'

/**
 * Returns the timestamp associated with a conversation for sorting purposes, and 0 if no timestamp is available.
 *
 * @param conversation - An Agent conversation object
 * @returns A Unix timestamp in milliseconds
 */
export const getConversationTimestamp = (conversation: AgentConversation): number => {
  if (conversation.updated_at) {
    // If it's a timestamp string, convert to number
    if (typeof conversation.updated_at === 'string') {
      return new Date(conversation.updated_at).getTime()
    }
    return conversation.updated_at as number
  }
  return 0 // Default if no timestamp is available
}
